var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResourceItemTable',_vm._g(_vm._b({attrs:{"resource":_vm.resource,"defaultSortBy":['str']}},'ResourceItemTable',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }